import { Component, OnInit, Input } from '@angular/core';
import { Schedule } from 'src/classes/schedule';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, FormArray, FormControl } from '@angular/forms';

function saveScheduleTypeOnLocalStorage(value: string) {
  if (!window.localStorage || !window.localStorage.setItem) {
    return;
  }
  window.localStorage.setItem('last-schedule-type', value);
}

function loadScheduleTypeFromLocalStorage(): string {
  if (!window.localStorage || !window.localStorage.getItem('last-schedule-type')) {
    return 'weekly';
  }
  const value = window.localStorage.getItem('last-schedule-type');
  // Check if user has valid schedule type since it can be tampered with
  if (['monthly', 'weekly', 'daily'].includes(value)) {
    return value;
  }
  return 'weekly';
}

function interpretRuleObject(type: string, obj: any) {
  if (type === 'default') {
    type = loadScheduleTypeFromLocalStorage();
  } else if (type.length !== 0) {
    switch (type.toLowerCase().substring(0, 1)) {
      case 'm': type = 'monthly'; break;
      case 'w': type = 'weekly'; break;
      case 'd': type = 'daily'; break;
      default: type = 'weekly';
    }
  }
  var days
  try{
    days = JSON.parse(obj.date)
  }
  catch(e){
    days = obj.date ? obj.date.toString() : '1';

  }
  const weekdays = obj.dayOfWeek ? obj.dayOfWeek : '1,2,3,4,5';

  let hour: number|number[] = 0;
  const minute = obj.minute || 0;
  if (typeof obj.hour === 'number') {
    hour = obj.hour;
  } else if (typeof obj.hour === 'object' && obj.hour instanceof Array) {
    if (type === 'daily') {
      hour = obj.hour as number[];
    } else if (typeof obj.hour[0] === 'number' || typeof obj.hour[0] === 'string') {
      hour = parseInt(obj.hour[0].toString(), 10);
    } else {
      hour = 0;
    }
  }
  let times;
  if (type === 'daily' && hour instanceof Array) {
    times = hour.map(
      hourUnit => hourUnit.toString().padStart(2, '0') + ':' + minute.toString().padStart(2, '0') + ' BRT'
    ).join(',');
  } else {
    times = hour + ':' + minute + ' BRT';
  }

  const time = times.split(',')[0];

  return { type, days, weekdays, times, time };
}

@Component({
  selector: 'app-schedule-form-modal',
  templateUrl: './schedule-form-modal.component.html',
  styleUrls: ['./schedule-form-modal.component.scss']
})
export class ScheduleFormModalComponent implements OnInit {

  @Input() schedule: Schedule;
  public forceFormShowError = false;
  public scheduleForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    const { type, days, weekdays, time, times } = interpretRuleObject(
      this.schedule ? this.schedule.type : 'default',
      this.schedule && this.schedule.rule ? JSON.parse(this.schedule.rule) : {}
    );
    console.log({times})
    this.scheduleForm = this.formBuilder.group({
      IdSchedule: [this.schedule ? this.schedule.idSchedules : 0],
      Recurrence: [type, Validators.required],
      Days: [days, Validators.required],
      Times: [times, Validators.required],
      Weekdays: [weekdays, Validators.required],
      Time: [time, Validators.required],
      Status: [this.schedule ? this.schedule.status === 'A' : true]
    });
  }

  get isNew(): boolean {
    return this.schedule && this.schedule.idSchedules !== null && this.schedule.idSchedules !== undefined;
  }

  onCancelClick() {
    this.activeModal.close(null);
  }

  onScheduleTypeChange(event) {
    saveScheduleTypeOnLocalStorage(event.target.value);
    this.Recurrence.setValue(event.target.value);
  }

  onSubmitClick() {
    if (this.scheduleForm.invalid) {
      this.forceFormShowError = true;
      return;
    }
    this.activeModal.close(this.scheduleForm.value);
  }

  onStatusSwitch() {
    const value = this.Status.value;
    this.Status.setValue(!value);
  }

  get IdSchedule() { return this.scheduleForm.get('IdSchedule'); }
  get Recurrence() { return this.scheduleForm.get('Recurrence'); }
  get Days() { return this.scheduleForm.get('Days'); }
  get Times() { return this.scheduleForm.get('Times'); }
  get Weekdays() { return this.scheduleForm.get('Weekdays'); }
  get Time() { return this.scheduleForm.get('Time'); }
  get Status() { return this.scheduleForm.get('Status'); }

}
